import Brand from "./Brand";

const Images = {
  appLogo: Brand.images.appLogo,
};

export default Images;
